export default __webpack_public_path__ + "static/media/check-blue.e60530b6.png";